module.exports = "/assets/data/07e90dbb6d1c9ef21c0b749b3e8ad098-CM1.data.json";